import type React from 'react';

const MAP: Record<string, { label: string; tone: string }> = {
  detected: { label: 'Detectado', tone: 'danger' },
  mitigated: { label: 'Mitigado', tone: 'success' },
  accepted_with_justification: { label: 'Aceito c/ justificativa', tone: 'info' },
  false_positive: { label: 'Falso positivo', tone: 'neutral' },
  resolved: { label: 'Resolvido', tone: 'success' },
  revoked: { label: 'Revogado', tone: 'neutral' },
  auto_resolved: { label: 'Auto-resolvido', tone: 'neutral' },
  // Status legados da Fatia C — preservados p/ compat no histórico (a query de
  // histórico do Engine ainda retorna esses). Sem entrada explícita o badge sumia.
  open: { label: 'Aberto', tone: 'danger' },
  acknowledged: { label: 'Reconhecido', tone: 'info' },
  accepted: { label: 'Aceito', tone: 'info' },
};

// Humaniza qualquer token não-catalogado ('some_legacy_state' → 'Some legacy state')
// para nunca renderizar coluna vazia no histórico.
function humanize(token: string): string {
  const s = token.replace(/_/g, ' ').trim();
  return s.length === 0 ? token : s.charAt(0).toUpperCase() + s.slice(1);
}

export interface ConflictAlertStatusBadgeProps {
  status: string;
}

export function ConflictAlertStatusBadge({
  status,
}: ConflictAlertStatusBadgeProps): React.JSX.Element {
  const m = MAP[status] ?? { label: humanize(status), tone: 'neutral' };
  return <span className={`alert-status alert-status--${m.tone}`}>{m.label}</span>;
}
